import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MenuPage from './pages/MenuPage';
import { getNewStoreData } from './services/util';
import { Box, CircularProgress, Typography } from '@mui/material';
import PaidInOut from './pages/PaidInOut';
// import CashCount from './pages/CashCount';
import StartOfDay from 'pages/StartOfDay';
import EndOfDay from 'pages/EndOfDay';
import SummaryPage from 'pages/SummaryPage';
import { checkCashManagementAuth } from 'api';

const App: React.FC = () => {
  const { accessToken, storeId } = getNewStoreData();
  const [authStatus, setAuthStatus] = useState<'checking' | 'authorized' | 'unauthorized'>('checking');
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    if (!accessToken || !storeId) {
      return;
    }

    setAuthStatus('checking');
    setAuthError(null);

    checkCashManagementAuth()
      .then(() => {
        if (isMounted) {
          setAuthStatus('authorized');
          setAuthError(null);
        }
      })
      .catch(err => {
        if (!isMounted) return;
        const message = err instanceof Error && err.message
          ? err.message
          : 'Unable to verify cash management access.';
        setAuthStatus('unauthorized');
        setAuthError(message);
        // setAuthError(JSON.stringify(err));
      });

    return () => {
      isMounted = false;
    };
  }, [accessToken, storeId]);

  if (!accessToken || !storeId) {
    return (
      <Box p={4}>
        <Typography color="error" variant="body1">
          Missing authentication or store context.
        </Typography>
      </Box>
    );
  }

  if (authStatus === 'checking') {
    return (
      <Box p={4} display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress />
        <Typography variant="body1">Verifying access...</Typography>
      </Box>
    );
  }

  if (authStatus === 'unauthorized') {
    return (
      <Box p={4}>
        <Typography color="error" variant="h6" gutterBottom>
          Access denied
        </Typography>
        <Typography variant="body1">
          {authError ?? 'You are not authorized to use the cash management application.'}
        </Typography>
      </Box>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <MenuPage />
          }
        />
        <Route path="/paid-in-out" element={<PaidInOut />} />
        {/* <Route path="/mid-day-count" element={<CashCount />} /> */}
        <Route path="/start-of-day" element={<StartOfDay />} />
        <Route path="/end-of-day" element={<EndOfDay />} />
        <Route path="/summary" element={<SummaryPage />} />
      </Routes>
    </Router>
  );
};

export default App;
